// extracted by mini-css-extract-plugin
export var productImage = "_rd-1";
export var viewLink = "_rd-2";
export var wishlistItem = "_rd-0";